import { useEffect, useState } from 'react'
import { useChord } from '@chordcommerce/react-autonomy/dist/hooks/use-chord'

export const useVariantOptions = ({ builderVariants }) => {
  const [variantOptions, setVariantOptions] = useState(null)

  const getVariantsBySkus = async (variants) => {
    try{
      const req = await fetch('/api/variants',{
        method: 'post',
        body: JSON.stringify(variants)
      } );
      const responseData = await req.json()
      return responseData.data
    } catch(e) {
      console.log('ERROR ON VARIANT REQUEST',e)
    }
  }
  useEffect(() => {
    if (builderVariants && !variantOptions) {
      const fetchVariantData = async () => {
        const variantData = await getVariantsBySkus(builderVariants.map((builderVariant) => builderVariant.sku))
        if (variantData?.count && variantData?.variants) {
          setVariantOptions(
            variantData.variants.map((variant, index) => {
              return {
                description: builderVariants.find(
                  (builderVariant) => builderVariant.sku === variant.sku
                )?.description,
                price: variant.price,
                quantity: variant['option_values'][0].presentation,
                sku: variant.sku,
                name: variant.name,
                slug: variant.slug,
                radioLabelText: builderVariants?.[index]?.radioLabelText
              }
            })
          )
        }
      }

      fetchVariantData()
    }
  }, [builderVariants, variantOptions])

  return { variantOptions }
}
